export default __webpack_public_path__ + "static/media/layout-1 (3).7ad1ee9b.jpg";